import axios from "axios";

import { TaskModel } from "@teamprevent/common/task/taskActions/models";

import { TaskType, TaskTypeFilters } from "../task/model";

export class TasksApi {
    public getSuccessorTasks = async (ohCaseId: string, taskId: string) =>
        (await axios.get<TaskType[]>(`/api/ohCase/${ohCaseId}/task/${taskId}/successorTasks`)).data;

    public removeAppointment = async (ohCaseId: string, taskId: string): Promise<void> =>
        (await axios.post(`/api/ohCase/${ohCaseId}/task/${taskId}/removeAppointment`)).data;

    public getAllTaskTypes = async (filters: TaskTypeFilters) => {

        let url = "/api/tasks/TaskTypes";

        url += `?type=${filters.type}&label=${filters.label}&taskCategory=${filters.taskCategories}`;

        return  (await axios.get<TaskType[]>(url)).data;
    };

    public getTaskType = async (taskType: string) =>
        (await axios.get<TaskType>(`/api/tasks/TaskTypes/${taskType}`)).data;

    public updateTaskType = async (taskType: TaskType) =>
        (await axios.post<TaskType>("/api/tasks/TaskTypes", taskType)).data;

    public getTask = async (ohCaseId: string, taskId: string): Promise<TaskModel> => {
        return (await axios.get<TaskModel>(`/api/ohCase/${ohCaseId}/task/${taskId}`)).data;
    };
}
